<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div class="text-right">
			<vButton @click="click" theme="primary">确定</vButton>
			<vButton class="margin-left-10" @click="cancel" >取消</vButton>
		</div>
	</div>
</template>
<script>
// import { mapState } from "vuex";
// import { HttpPlatform } from "@/service/boss/dictionary";
import { HttpPlatformName } from "@/service/managechannel/managechannel";
import TableList from "@components/templates/tablelist"
export default {
	props:['accounts','accountTypeList','countries'],
	components: {
		TableList
	},
	methods: {
		checkChange(rows, val) {
			// console.log(rows)
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
        getSiteNames(){
            let accountType=[];let siteName =[];let siteCountry = [];
			this.accounts.map(json => {
				if(json.attach.siteName!=''){
					siteName.push(json.attach.siteName) 
				}
            });
			let siteNames = [...new Set(siteName)]
            return siteNames
        },
        getAccountList(){
            let types = [];
            this.accountTypeList.map(function(item){
                types.push(item.attach.type)
            })
            return [...new Set(types)]
        },
		getData() {
			
			return {
				initFormData: {
					"search[EQ_level]":2
				},
				ajaxRequest: HttpPlatformName,
				startUp: true,
				Searchs: {
					show: true,
					style: "border:none;",
					// labelWidth: 'auto',
					align: "left"
				},
				SearchsData: [{
					label: "渠道类型",
					tag: 'vSelect',
					key: 'CN_name',
					show: true,
                    hideSearchTip: true,
					options:this.getAccountList.map(function(item){
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        filterable:true,
                    }
				}, {
					label: "站点名称",
					tag: 'vSelect',
					key: 'CN_name',
					show: true,
                    hideSearchTip: true,
					options:this.getSiteNames.map(function(item){
                        // const {accountType}=item;
                        return {
                            value:item,
                            label:item
                        }
                    }),
                    props:{
                        filterable:true,
                    },
				},{
					label: "国家",
					tag: 'vSelect',
					key: 'EQ_country',
					show: true,
					options:this.countries.map(function(item){
                        const {code,nameEn} = item;
                        return {
                            value:code,
                            label:code + ' (' + nameEn + ')'
                        }
                    }),
                    props:{
                        filterable:true,
                    },
				}],
				columns: [{
					type: 'selection',
					width: 60,
					align: "center",
					formName: 'id',
					isRadio:true,
				}, {
					title: "渠道类型",
					key: 'name'
				}, {
					title: "站点名称",
					key: 'name'
				}, {
					title: "站点国家",
					key: 'country',
				}]
			}
		}
	},
}
</script>